import { Component, OnInit, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MachineService } from '../../services/machine.service';
import { ActivityService } from '../../services/activity.service';
import { toast, MaterializeAction } from 'angular2-materialize';
import { UnitService } from '../../services/unit.service';
import { Utils } from '../../util';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-update-machine',
  templateUrl: './update-machine.component.html',
  styleUrls: ['./update-machine.component.css']
})
export class UpdateMachineComponent implements OnInit {
  loading: boolean[] = Array(3).fill(false);
  get loaded(): boolean { return !this.loading.includes(false); }

  id: string = '';

  form: FormGroup;

  activitys: any = {};
  activityIds: string[] = [];
  unitSelect: any[] = [];

  pickadateParams = Utils.pickadateParams();

  constructor(
    private service: MachineService,
    private activityService: ActivityService,
    private unitService: UnitService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute
  ) {
    this.id = activatedRoute.snapshot.paramMap.get('id');

    let activitySub = this.activityService.getActivities({
      onEmpty: () => {
        toast('Advertencia: no hay actividades registradas.');
        this.loading[0] = true;
      }
    }).subscribe(activitys => {
      activitySub.unsubscribe();
      this.rowsRead[0] = activitys.map(({id, name, activityClassObj: {name: classification}}) => {
        this.activitys[id] = {name, classification};
        return {id, name, classification};
      })
      this.loading[0] = true;
    });
    let unitSub = this.unitService.getUnits().subscribe(units => {
      unitSub.unsubscribe();
      units = units.filter(({type}) => type == 'Longitud').sort(({name: n1}, {name: n2}) => n1 > n2 ? 1 : -1);
      this.unitSelect = units.map(unit => ({ value: unit.id, name: `${unit.name} - ${unit.symbol}` }) );
      this.loading[1] = true;
    });
  }

  ngOnInit() {
    this.createForm();
    let sub = this.service.getMachine(this.id).subscribe(({activityIds, ...machine}) => {
      sub.unsubscribe();
      this.form.patchValue(machine);
      this.activityIds = activityIds;
      this.loading[2] = true;
    });
  }

  createForm() {
    this.form = this.fb.group({
      folio: ['', Validators.required],
      name: ['', Validators.required],
      date: '',
      warrantyTime: '',
      notes: '',
      headers: '',
      maxWidth: '',
      maxWidthUnitId: '',
      maxLong: '',
      maxLongUnitId: '',
      clawWidth: '',
      clawWidthUnitId: '',
      clawLong: '',
      clawLongUnitId: '',
    });
  }

  onSubmit({ value, valid }: { value: any, valid: boolean }){
    let machine = { activityIds: this.activityIds, ...value };
    let sub = this.service.getMachineByFolio(machine.folio).subscribe(([repeated]) => {
      sub.unsubscribe();
      if(repeated && repeated.id != this.id) return toast('El folio ya es ocupado por otra máquina.', 3000);
      this.service.updateMachine(this.id, machine);
      this.service.window.read();
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA
  currentReadIndex: number;

  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  openModalRead(index: number) {
    this.currentReadIndex = index;
    this.data = this.rowsRead[index];
    
    this.config = this.configs[index];
  
    this.onChangeTable(this.config);
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead({row: machine}): any{
    this.activityIds.push(machine.id);
    this.closeModalRead();
    console.log(this.activitys, this.activityIds);
  }

  rowsRead = [[]];
  columnsRead = [
    [//activity
      { title: 'Nombre', name: 'name', sort: 'asc' },
      { title: 'Clasificación', name: 'classification' }
    ]
  ]

  data:Array<any>;
  rows:Array<any> = [];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config;
  configs:any = this.columnsRead.map(columns => ({
    paging: true,
    sorting: {columns: columns},
    filtering: {filterString: ''}
  }));

  /*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columnsRead[this.currentReadIndex].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columnsRead[this.currentReadIndex].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA


}
